import { useAuth } from "@/hooks/use-auth";
import { useOauth } from "@/hooks/use-oauth";
import { AuthProvider } from "@/models/enums/auth-provider";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import LoginPageContent from "./-components/LoginPageContent";

const schema = z.object({
  token: z.string().optional(),
  telegram_id: z.coerce.string().optional(),
  ref: z.string().optional(),
});

export const Route = createFileRoute("/login/")({
  head: () => ({
    meta: [{ title: "Reactor | Login" }],
  }),
  validateSearch: (search) => {
    return schema.parse(search);
  },
  component: LoginPage,
});

function LoginPage() {
  const {
    login,
    isLoading: isTelegramLoading,
    onContinue,
    response,
  } = useAuth();
  const { initiateOauth: initGoogleLogin, isLoading: isGoogleLoading } =
    useOauth(AuthProvider.GOOGLE);
  const { initiateOauth: initDiscordLogin, isLoading: isDiscordLoading } =
    useOauth(AuthProvider.DISCORD);
  const { ref } = useSearch({ from: "/login/" });

  useEffect(() => {
    login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginPageContent
      isGoogleLoading={isGoogleLoading}
      initiateGoogleLogin={initGoogleLogin}
      isDiscordLoading={isDiscordLoading}
      initiateDiscordLogin={initDiscordLogin}
      isTelegramLoading={isTelegramLoading}
      recoveryKey={response?.recovery_key}
      onRecoveryKeyContinue={onContinue}
      ref={ref}
    />
  );
}
